import styled from '@emotion/styled';
import { SPACING, FONT, utils } from '../../styles/emotion';
import { FilterPillContainer } from './FilterPill.styles';

export const FilterPillsWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${SPACING.XS};
  overflow-x: auto;
  ${utils.concealScrollbars}

  ${FilterPillContainer} {
    margin: 0;
  }
`;

export const FilterPillsContainer = styled.div`
  position: relative;

  ::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 24px;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255));
  }
`;

export const ClearBtn = styled.div`
  font-size: ${FONT.FONT_SIZE_SMALLER};
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  text-decoration-line: underline;
  cursor: pointer;
`;
